import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomCookieService } from 'src/app/shared/services/custom-cookie.service';
import { IdValidationRequestBody, IdValidationResponse } from '../../../../shared/common/classes';
import { AuthorizationService } from '../../../../shared/services/authorization.service';
import { LoaderService } from '../../../../shared/services/loader.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public boxesText = [
    {
      title: 'Get Verizon connectivity for your vehicle.',
      texts: [
        'Unlock the power of best in class Verizon connectivity. Enjoy infotainment, music, mobile hotspot and a lot more in your vehicle.',
        'In order to use this functionality in your compatible vehicle, please ensure  your vehicle’s software is updated to the latest available version. Contact your vehicle manufacturer for more information.',
      ]
    },
    {
      title: 'Easily switch between cars with Multi-Vehicle Connect.',
      texts: [
        'Access your data from up to 3 eligible vehicles paired with your plan. Your data plan is enabled when you login to qualifying vehicles.'
      ]
    },
    {
      title: 'Your car is your phone, with Number Share - Vehicle.',
      texts: [
        'Pair your vehicle to your phone and your vehicle can receive and make voice calls on Verizon’s nationwide network without requiring your phone.'
      ]
    }
  ]
  public behaviourSchema: {
    signInLink: string,
    queryParams: object
  };
  public viewMode: string;
  constructor(
    private _renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authorizationService: AuthorizationService,
    private customCookieService: CustomCookieService,
    private loaderService: LoaderService
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.viewMode = params.mode;
      const { id, redirect_uri, redirect_url } = params;
      const requestBody: IdValidationRequestBody = {
        clientID: id,
        redirect_uri: redirect_uri || redirect_url || ''
      }
      /// Persist clinetid and redirect_uri for internal ui needs ///
      if (id) this.customCookieService.saveData('ui-clinetId', id, '/', true);
      if (redirect_uri) this.customCookieService.saveData('ui-redirect_uri', params.redirect_uri, '/', true);
      this.authorizationService.validateClientId(requestBody)
        .subscribe(
          {
            next: (response: IdValidationResponse) => {
              let validateResponse: IdValidationResponse = response;
            },
            error: (error: any) => {
              console.log('Error')
              this.router.navigate(['main/invalid-clientid']);
            }
          })
    })
  }

  public goSignIn() {
    this.router.navigate(['sign-in']);
  }

  public redirectSignIn() {
    this.loaderService.show()
    setTimeout(() => { this.loaderService.hide() }, 4000)
    console.log(`host = ${window.location.hostname}`)
    if (window.location.hostname === "localhost") {
      // rename below cookes domain to localhost after you login to dev/qa/staging to test localhost
      // 'x-sm-session', correlationId, 'x-request-id', sso_jwt, caseData, aaidjwt
      window.location.assign('/account/mdn');
    } else {
      window.location.assign('/secure/login');
    }
  }

}
